import React, { Component } from "react";
import classNames from "classnames";
import data from "../../data/data";
import "./PieceOfNews.css";
import { connect } from "react-redux";
import { routeCodes } from "../../config/routes";
import { NavLink, withRouter } from "react-router-dom";

class PieceOfNews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      containerWidth: 0,
      translateXValue: 0,
      currentImageStep: 0
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  componentDidMount() {
    const newsData =
      this.props.location.state !== undefined
        ? this.props.location.state.data
        : data.news[0];
    const numberOfLandscapeImages = document.querySelectorAll(
      ".SingleCollection-image--ls"
    ).length;
    this.setState({
      numberOfLandscapeImages,
      containerWidth:
        newsData.gallery.length * 50 + numberOfLandscapeImages * 50
    });
    document.addEventListener("keydown", this.handleKeyDown);
  }

  handleKeyDown(e) {
    const LEFT_ARROW = e.keyCode === 37;
    const RIGHT_ARROW = e.keyCode === 39;
    if (LEFT_ARROW) {
      this.switchImages("prev");
    } else if (RIGHT_ARROW) {
      this.switchImages("next");
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  handleTouchStart(event) {
    this.x = event.touches[0].clientX;
    this.y = event.touches[0].clientY;
  }

  handleTouchMove(event) {
    this.xM = event.changedTouches[0].clientX;
    this.yM = event.changedTouches[0].clientY;
    const xDiff = this.xM - this.x;
    const yDiff = this.yM - this.y;
    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      if (xDiff > 0) {
        this.switchImages("prev");
      } else {
        this.switchImages("next");
      }
    }
    this.x = null;
    this.y = null;
  }

  switchImages(direction) {
    const { currentImageStep, containerWidth } = this.state;
    const maxSteps = Math.floor(containerWidth / 110);
    if (direction === "next") {
      this.setState({
        currentImageStep:
          currentImageStep === maxSteps ? 0 : currentImageStep + 1
      });
    } else {
      this.setState({
        currentImageStep:
          currentImageStep === 0 ? maxSteps : currentImageStep - 1
      });
    }
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const newsData =
      this.props.location.state !== undefined
        ? this.props.location.state.data
        : data.news[0];
    const { containerWidth, currentImageStep } = this.state;
    const translateXValue = (100 / (containerWidth / 100)) * currentImageStep;
    const { language } = this.props;
    return (
      <div className="PieceOfNews-Main">
        <div className="PieceOfNews">
          <div className="PieceOfNews-text">{newsData.bigTitle}</div>
          <div className="PieceOfNews-content">
            <div className="PieceOfNewsBorder" />
            <h4 className="PieceTitle">{newsData.title}</h4>
            <span className="PieceSubTitle">{newsData.subtitle}</span>
            <p className="PieceDesc">{newsData.desc}</p>
          </div>
          <div className="ImageWrap">
            <div
              className="PieceOfNews-image"
              style={{ backgroundImage: `url(${newsData.image2})` }}
            />
            <div
              className="PieceOfNews-image2"
              style={{ backgroundImage: `url(${newsData.image})` }}
            />
          </div>
          <div className="PiecePhoto--Mobile">
            <div
              className="Piece-imageMobile2"
              style={{ backgroundImage: `url(${newsData.image})` }}
            />
          </div>
        </div>
        <div className="MainWrapper">
          <div className="TextBlock">
            <p>{newsData.descriptionfull}</p>
          </div>
          <div
            className="ImagesWrapper"
            onTouchStart={event => this.handleTouchStart(event)}
            onTouchEnd={event => this.handleTouchMove(event)}
          >
            <div className="MobileButtons">
              <button
                onClick={() => this.switchImages("prev")}
                className="SingleCollection-ButtonM"
              >
                <svg
                  className="SvgPrev"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                </svg>
              </button>
              <button
                onClick={() => this.switchImages("next")}
                className="SingleCollection-ButtonM ButtonM"
              >
                <svg
                  className="SvgNext"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
                </svg>
              </button>
            </div>
            <button
              onClick={() => this.switchImages("prev")}
              className="SingleCollection-Button2"
            >
              <div className="Button-div">
                <svg
                  className="SvgPrev"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z" />
                </svg>
              </div>
            </button>
            <div className="SingleCollection-RelativeDiv2">
              <div
                className="SingleCollection-images"
                style={{
                  width: `${containerWidth}%`,
                  transform: `translateX(-${translateXValue}%)`
                }}
              >
                {newsData.gallery.map((item, index) => {
                  const imageClasses = classNames(
                    "SingleCollection-image",
                    item.orientation === "landscape" &&
                      "SingleCollection-image--ls"
                  );
                  return (
                    <div
                      className={imageClasses}
                      key={index}
                      style={{ backgroundImage: `url(${item.image})` }}
                    />
                  );
                })}
              </div>
            </div>
            <button
              onClick={() => this.switchImages("next")}
              className="SingleCollection-Button2"
            >
              <div className="Button-div">
                <svg
                  className="SvgNext"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
                </svg>
              </div>
            </button>
          </div>
        </div>
        <div className="NewsBottom">
          <div className="BorderLeft" />
          <NavLink
            className="NewsButton"
            onClick={() => this.scrollToTop()}
            to={routeCodes.NEWS}
          >
            {data.newsButton.backToNews[language]}
          </NavLink>
          <div className="BorderRight" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(PieceOfNews));



// WEBPACK FOOTER //
// ./src/views/PieceOfNews/index.js